import posthogProxyConfig from './posthog-proxy.config.json'

export const DEFAULT_POSTHOG_PROXY_PATH = posthogProxyConfig.defaultProxyPath

export function getPosthogProxyPath() {
  return process.env.NEXT_PUBLIC_POSTHOG_PROXY_PATH || DEFAULT_POSTHOG_PROXY_PATH
}
